import { createContext, useContext, useMemo, useState } from 'react';
import { clearAccessToken, ensureAccessToken } from './auth/token.service';

const AuthContext = createContext(null);

const VALID_USER = (process.env.REACT_APP_AUTH_USER || 'minute1').trim().toLowerCase();
const VALID_PASS = (process.env.REACT_APP_AUTH_PASS || 'marketing').trim();

export default function AuthProvider({ children }) {
  const [isLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(() => localStorage.getItem('auth:ok') === '1');

  const login = async (username, password, remember) => {
    const normalized = (username || '').trim().toLowerCase();

    if (normalized !== VALID_USER || password !== VALID_PASS) {
      return { success: false, message: 'Invalid username or password' };
    }
    try {
      await ensureAccessToken({ forceRefresh: true });
      setIsAuthenticated(true);
      if (remember) localStorage.setItem('auth:ok', '1');
      return { success: true };
    } catch (err) {
      return { success: false, message: err.message || 'Authentication failed' };
    }
  };
  const logout = () => {
    clearAccessToken();
    setIsAuthenticated(false);
    localStorage.removeItem('auth:ok');
  };

  const value = useMemo(
    () => ({
      isLoading,
      isAuthenticated,
      login,
      logout,
    }),
    [isLoading, isAuthenticated],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
